import {List} from 'immutable'

// Placeholder emails are generated by the Rails API for Sales Studio clients created
// without a usable email. No email (including invites) may ever be sent to them.
export const PLACEHOLDER_EMAIL_DOMAIN = 'everplan-placeholder.com'

export const isPlaceholderEmail = email => typeof email === 'string' && email.trim().toLowerCase().endsWith(`@${PLACEHOLDER_EMAIL_DOMAIN}`)

export const domainEmailRegex = domainName => new RegExp(`^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+.)?[a-zA-Z]+.)?(${domainName})$`, 'g')

export const deputizableDomainEmails = ({contact, organization}) => {
  const emails = contact.get('emails') || List()

  if (organization.get('block-deputization'))
    return emails.filter(email => !domainEmailRegex(organization.get('domain-names')).test(email))
  else
    return emails
}
